/**
 * Grava preferências pela tela de Configurações: na hora, com o aviso "Preferência salva" (o Toaster
 * junta avisos iguais, então arrastar um controle não empilha avisos).
 */
import { useCallback } from 'react';
import { useT } from '../i18n/index.js';
import type { AppSettings } from '../settings.js';
import { useApp } from '../store.js';
import { toast } from '../ui/Toaster.js';

export function useSavePrefs(): (patch: Partial<AppSettings>) => void {
  const update = useApp((s) => s.updateSettings);
  const t = useT();
  return useCallback(
    (patch) => {
      update(patch);
      toast(t('prefs.saved'), 'success');
    },
    [update, t],
  );
}
